/* Cart-drawer — openen/sluiten, aantallen, verwijderen, toevoegen vanuit "You may also like".
   Na elke mutatie wordt de sectie opnieuw opgehaald (Section Rendering API), zodat prijzen,
   kortingsstaffel en aanbevelingen door Liquid worden berekend en niet in JS worden nagebouwd. */
(function () {
  var root = document.getElementById('cart-drawer');
  if (!root) return;

  var body = root.querySelector('[data-cd-body]');
  var busy = false;

  /* ── openen / sluiten ── */
  function open() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cd-open');
    var close = root.querySelector('[data-cd-close]');
    if (close) close.focus();
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cd-open');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cd-open], a[href="/cart"], a[href$="/cart"]');
    if (trigger && !trigger.hasAttribute('data-cd-ignore')) {
      e.preventDefault();
      refresh().then(open);
    }
  });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-close]') || e.target.classList.contains('cd-scrim')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  /* ── sectie opnieuw renderen ── */
  function refresh() {
    /* 26-08: de lade zit nu in sectiegroep 'cart-group' zodat hij in de theme editor
       staat. Daardoor is het sectie-id dynamisch — Liquid zet het in data-section-id. */
    var el = root.querySelector('.drawer.cd');
    var sid = (el && el.getAttribute('data-section-id')) || 'cart-drawer';
    return fetch('/?section_id=' + encodeURIComponent(sid), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.drawer.cd');
        if (fresh && body) {
          body.innerHTML = fresh.outerHTML;
          syncCount(fresh.getAttribute('data-cart-count'));
          setTimeout(syncProt, 0);
        }
        return syncGift();
      })
      .catch(function () { /* netwerkfout: drawer laat gewoon de vorige stand zien */ });
  }

  /* ── free gift (18-09): vanaf X gekochte stuks gaat het cadeau automatisch mee, eronder weer
     eruit, en nooit meer dan 1. Werkt op de data-attributen die Liquid op .prog.gift zet. ── */
  var gifting = false, giftTries = 0;   /* max 2 pogingen per stand: nooit een eindeloze lus als toevoegen faalt */
  function syncGift() {
    var g = root.querySelector('.prog.gift');
    if (!g || gifting) return;
    var variant = parseInt(g.getAttribute('data-gift-variant'), 10);
    var need = parseInt(g.getAttribute('data-gift-qty'), 10) || 5;
    var paid = parseInt(g.getAttribute('data-paid'), 10) || 0;
    var inCart = parseInt(g.getAttribute('data-gift-in'), 10) || 0;
    var line = parseInt(g.getAttribute('data-gift-line'), 10) || 0;
    var req = null;
    if (paid >= need && inCart === 0 && variant) {
      req = ['/cart/add.js', { items: [{ id: variant, quantity: 1, properties: { _gift: 'free' } }] }];
    } else if (paid < need && inCart > 0 && line) {
      req = ['/cart/change.js', { line: line, quantity: 0 }];
    } else if (inCart > 1 && line) {
      req = ['/cart/change.js', { line: line, quantity: 1 }];
    }
    if (!req) { giftTries = 0; return; }
    if (giftTries >= 2) return;
    giftTries++;
    gifting = true;
    return fetch(req[0], { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(req[1]) })
      .catch(function () {})
      .then(function () {
        gifting = false;
        /* 01-10 (Casa Rosa): op de losse /cart-pagina staat de inhoud buiten de lade; daar helpt
           refresh() niet. Dan de pagina herladen — hooguit 2x per minuut, zodat een mislukte
           toevoeging nooit een herlaad-lus wordt. */
        if (document.querySelector('.cd-standalone')) {
          try {
            var nu = Date.now(), log = JSON.parse(sessionStorage.getItem('giftReload') || '[]').filter(function (t) { return nu - t < 60000; });
            if (log.length < 2) { log.push(nu); sessionStorage.setItem('giftReload', JSON.stringify(log)); location.reload(); return; }
          } catch (e) {}
        }
        return refresh();
      });
  }
  /* bij het laden één keer gelijktrekken: wie rechtstreeks op /cart komt (of terugkomt met een
     volle wagen) krijgt het cadeau ook zonder eerst de lade te openen */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncGift(); });
  else syncGift();

  function syncCount(n) {
    document.querySelectorAll('.count, [data-cart-count-bubble]').forEach(function (el) {
      if (el.closest('#cart-drawer')) return;
      el.textContent = n;
    });
  }

  /* ── 22-10 verzendbescherming: standaard aan. Zet de klant hem uit, dan blijft hij uit (per sessie).
     Leest de data-attributen die Liquid op [data-prot] zet. Max 2 pogingen per stand: nooit een lus. ── */
  var protBusy = false, protTries = 0;
  function protOff() { try { return sessionStorage.getItem('protOff') === '1'; } catch (e) { return false; } }
  function protEl(scope) {
    return (scope && scope.querySelector('[data-prot]')) ||
      document.querySelector('.cd-standalone [data-prot]') || root.querySelector('[data-prot]');
  }
  function protReq(url, payload) {
    protBusy = true;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .catch(function () {})
      .then(function () {
        protBusy = false;
        /* op de losse /cart-pagina staat de kaart buiten de lade: herladen, hooguit 2x per minuut */
        if (document.querySelector('.cd-standalone')) {
          try {
            var nu = Date.now(), log = JSON.parse(sessionStorage.getItem('protReload') || '[]').filter(function (t) { return nu - t < 60000; });
            if (log.length < 2) { log.push(nu); sessionStorage.setItem('protReload', JSON.stringify(log)); location.reload(); return; }
          } catch (e) {}
        }
        return refresh();
      });
  }
  function syncProt() {
    var p = protEl();
    if (!p || protBusy) return;
    var vid = parseInt(p.getAttribute('data-prot-variant'), 10);
    var inC = parseInt(p.getAttribute('data-prot-in'), 10) || 0;
    var line = parseInt(p.getAttribute('data-prot-line'), 10) || 0;
    var paid = parseInt(p.getAttribute('data-paid'), 10) || 0;
    var req = null;
    if (paid > 0 && inC === 0 && vid && !protOff()) req = ['/cart/add.js', { items: [{ id: vid, quantity: 1 }] }];
    else if (paid === 0 && inC > 0 && line) req = ['/cart/change.js', { line: line, quantity: 0 }];
    else if (inC > 1 && line) req = ['/cart/change.js', { line: line, quantity: 1 }];
    if (!req) { protTries = 0; return; }
    if (protTries >= 2) return;
    protTries++;
    return protReq(req[0], req[1]);
  }
  document.addEventListener('change', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-prot-toggle]');
    if (!t) return;
    var card = t.closest('.cd') || document;
    var p = protEl(card);
    if (!p) return;
    try { sessionStorage.setItem('protOff', t.checked ? '0' : '1'); } catch (err) {}
    var row = t.closest('.cd-prot');
    if (row) row.classList.add('is-busy');
    protTries = 0;
    var vid = parseInt(p.getAttribute('data-prot-variant'), 10);
    var line = parseInt(p.getAttribute('data-prot-line'), 10) || 0;
    if (t.checked && vid) protReq('/cart/add.js', { items: [{ id: vid, quantity: 1 }] });
    else if (!t.checked && line) protReq('/cart/change.js', { line: line, quantity: 0 });
    else if (row) row.classList.remove('is-busy');
  });
  /* bij het laden één keer gelijktrekken (wie met een volle wagen binnenkomt of rechtstreeks op /cart) */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncProt(); });
  else syncProt();

  /* ── cart-mutaties ── */
  function post(url, payload) {
    if (busy) return Promise.resolve();
    busy = true;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data && res.data.description ? res.data.description : 'cart error');
        return refresh();
      })
      .catch(function (err) {
        var note = root.querySelector('[data-cd-error]');
        if (note) { note.textContent = err.message; note.hidden = false; }
      })
      .then(function () { busy = false; });
  }

  root.addEventListener('click', function (e) {
    var qty = e.target.closest('[data-cd-qty]');
    if (qty) {
      var line = qty.getAttribute('data-cd-qty');
      var to = parseInt(qty.getAttribute('data-to'), 10);
      var row = qty.closest('.item');
      if (row) row.classList.add('is-busy');
      post('/cart/change.js', { line: parseInt(line, 10), quantity: Math.max(0, to) });
      return;
    }

    var rm = e.target.closest('[data-cd-remove]');
    if (rm) {
      var row2 = rm.closest('.item');
      if (row2) row2.classList.add('is-busy');
      post('/cart/change.js', { line: parseInt(rm.getAttribute('data-cd-remove'), 10), quantity: 0 });
      return;
    }

    var add = e.target.closest('[data-cd-add]');
    if (add) {
      var card = add.closest('[data-cd-rec]');
      var picker = card && card.querySelector('[data-cd-variant]');
      if (!picker || !picker.value) return;
      add.disabled = true;
      post('/cart/add.js', { items: [{ id: parseInt(picker.value, 10), quantity: 1 }] });
      return;
    }

    var prev = e.target.closest('[data-cd-prev]');
    var next = e.target.closest('[data-cd-next]');
    if (prev || next) {
      var track = root.querySelector('[data-cd-track]');
      if (track) track.scrollBy({ left: (next ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
    }
  });

  /* ── openen na 'add to cart' elders op de pagina ── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action$="/cart/add"]')) return;
    e.preventDefault();
    var fd = new FormData(form);
    busy = false;
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function () { return refresh(); })
      .then(open)
      .catch(function () { form.submit(); });
  });

  /* ?cart=open → drawer meteen tonen (handig na een redirect) */
  if (new URLSearchParams(location.search).get('cart') === 'open') {
    refresh().then(open);
  }
})();
